import React from 'react';
import ReactDOM from 'react-dom';
import App from './views/App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { ThemeProvider } from 'styled-components';
import * as theme from './views/globals/theme';
import {Helmet} from 'react-helmet';

ReactDOM.render(
  <ThemeProvider theme={theme}>
  	<Helmet>
      <title>bantuin | berbagi layanan</title>
      <meta name="description" content="Bantuin, sebuah aplikasi untuk berbagi layanan serta mencari orang yang tepat untuk membantu proyek anda" />
    </Helmet>
    <App />
  </ThemeProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
